module.exports = __webpack_public_path__ + "img/poisson.ca241884.svg";